import React, { FC, Fragment } from 'react';

import Advertisement from '@/components/advertisement';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';
import { Channel as ChannelT, ChannelGroupType } from '@/types/views/generic';

import Channel from './channel';
import { channelList as styles } from './styles';

interface ChannelListProps {
  type: ChannelGroupType;
  channels: ChannelT[];
  isEventTheme: boolean;
  onPlaylistIconClick: () => void;
  showAdAfterFirstChannel?: boolean;
  mobileAdContainerRef?: (node: HTMLDivElement | null) => void;
}

const ChannelList: FC<ChannelListProps> = ({
  type,
  channels,
  isEventTheme,
  onPlaylistIconClick,
  showAdAfterFirstChannel = false,
  mobileAdContainerRef,
}) => {
  const variables = useVariables();

  return (
    <div className={styles.wrapper}>
      <strong className={styles.text}>
        {getVariablePlainText(variables[`channel-switcher-mobile-${type}`])}
      </strong>

      {channels.map((channel, index) => (
        <Fragment key={channel.id}>
          <Channel
            channel={channel}
            channelGroup={type}
            isEventTheme={isEventTheme}
            onPlaylistIconClick={onPlaylistIconClick}
          />
          {showAdAfterFirstChannel && index === 0 && mobileAdContainerRef ? (
            <div className="channel-switcher-mobile-ad content-box py-3 min-h-[250px]">
              <Advertisement
                ref={mobileAdContainerRef}
                slot="index_ad_1"
                slotId="ad-slot-index_ad_1-channel-switcher"
              />
            </div>
          ) : null}
        </Fragment>
      ))}
    </div>
  );
};

export default ChannelList;
